import type {
	PresenceDto,
	PresenceListItemDto,
	PresenceChangeModel,
} from "@/repository/models";
import { Client, Controller, Endpoint, mapUrl } from "@/repository";
import type { QueryFunctionContext } from "@tanstack/react-query";

export const presencesQueryKey = "presences";

export const fetchPresencesFn = (_: QueryFunctionContext) => {
	const url = mapUrl(Controller.Presence, Endpoint.List);

	return Client.instance.get<PresenceListItemDto[]>(url);
};

export const getCurrentPresence = (): Promise<PresenceDto> => {
	return Client.instance.get(mapUrl(Controller.Presence));
};

export const UserInternalPresenceKey = "userInternalPresenceKey";

export const getUserInternalPresence = (userId: string): Promise<PresenceDto> => {
	return Client.instance.get(mapUrl(Controller.Presence, Endpoint.User, userId));
};

export const verifyHasClient = (): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Presence, Endpoint.VerifyHasClient)
	);
};

export const azurePresence = (): Promise<PresenceDto> => {
	return Client.instance.get(mapUrl(Controller.Presence, Endpoint.Azure));
};

export const changePresence = (presence: PresenceChangeModel): Promise<any> => {
	return Client.instance.post<PresenceChangeModel>(
		mapUrl(Controller.Presence),
		presence
	);
};

export const changeWrapUpCode = (
	presence: PresenceChangeModel
): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Presence, Endpoint.WrapUpCode),
		presence
	);
};
